import Slider from 'components/3catinfo/Slider';
import DestacatPrograma from './DestacatPrograma';
import __isEmpty from 'lodash/isEmpty';
import styles from './programesDestacats.module.scss';

const ProgramesDestacats = (props) => {
    const { items, titol, infoBlocRedl, descripcio = '', mostraIcona = false, novaFinestra = true } = props;

    return (
        <>
            {items && (
                <div className={styles.contDestacatPrograma}>
                    <Slider
                        format='poster-programa-destacat'
                        estilModul='poster-programa-destacat'
                        titol={titol}
                        fletxes='mig'
                        descripcio={descripcio}
                    >
                        {items?.map((item, index) => {
                            return (
                                <DestacatPrograma
                                    key={`destacat-programa-${item.id}`}
                                    item={item}
                                    index={index + 1}
                                    infoBlocRedl={infoBlocRedl}
                                    mostraIcona={mostraIcona}
                                    novaFinestra={novaFinestra}
                                />
                            );
                        })}
                    </Slider>
                </div>
            )}
        </>
    );
};

export default ProgramesDestacats;
